module.exports = __webpack_public_path__ + "img/l_ico.9e95e1c0.svg";